import React from 'react';
// import DataTableViewer from '../DataTable/DataTableViewer';
import { Card, CardBody, CardExpandToggler } from '@components/card/card';
// import Charts from '../../../../../Charts/Index';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CardHeader } from 'react-bootstrap';
import Charts from '../Charts';

interface Props {
  DataReport: any;
  chartList: any[] | undefined;
  DataChartReport: any;
  RequestPrint: any;
}

const TabsReports: React.FC<Props> = ({ DataChartReport, DataReport, chartList, RequestPrint }) => {
  const { t, i18n } = useTranslation();

  return (
    <Card>
      <CardHeader className="p-0">
        <div className="d-flex fw-bold ">
          <span className="flex-grow-1">
            <ul className="nav nav-tabs nav-tabs-v2 px-4 text-nowrap">
              <li className="nav-item me-3">
                <Link
                  to="#1"
                  className="nav-link active px-2 pb-1 text-center"
                  data-bs-toggle="tab">
                  <div className="nav-field">{t('Report')}</div>
                  <div className="nav-value mt-1">
                    <i
                      className="fa-lg bi bi-file-spreadsheet"
                      style={{ color: 'var(--bs-theme)' }}></i>
                  </div>
                </Link>
              </li>

              {chartList?.map((item, index) => (
                <li className="nav-item me-3" key={++index}>
                  <Link
                    to={`#${item.id}`}
                    className="nav-link px-2 pb-1 text-center"
                    data-bs-toggle="tab">
                    <div className="nav-field me-2">
                      {i18n.language === 'en' ? item.name : item.name2}
                    </div>
                    <div className="nav-value mt-1">
                      <i className={item.icon} style={{ color: 'var(--bs-theme)' }}></i>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </span>

          <span className="py-4 px-3">
            <CardExpandToggler />
          </span>
        </div>
      </CardHeader>
      <CardBody>
        <div className="tab-content">
          <div className="tab-pane fade show active" id="1">
            {/* {Object.keys(DataReport)?.length > 0 && (
              <DataTableViewer DataReport={DataReport} RequestPrint={RequestPrint} />
            )} */}
          </div>

          {chartList?.map((item, index) => (
            <div className="tab-pane fade" id={item.id} key={++index}>
              {DataChartReport?.map((m: any, idx: number) => (
                <div className="col-8 m-auto" key={++idx}>
                  {item.name === m?.title ? <Charts key={++idx} DataChartReport={m} /> : null}
                </div>
              ))}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default TabsReports;
